import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UserService } from '../../user/user.service';
import { Router } from '@angular/router';

@AutoUnsubscribe()
@Component({
  selector: 'app-student-search-warning',
  templateUrl: './student-search-warning.component.html',
  styles: []
})
export class StudentSearchWarningComponent implements OnInit, OnDestroy {

  constructor(
    private userService: UserService,
    private router: Router,
    private dialogRef: MatDialogRef<StudentSearchWarningComponent>
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  okClick() {
    if (sessionStorage.getItem('loginFromLegacy') != null || sessionStorage.getItem('loginFromLegacy') == '1') {
      window.close();
    } else {
      this.router.navigateByUrl('/login');
      setTimeout(() => {
        window.location.reload();
      }, 0);
    }
  }

  cancelClick() {
    this.dialogRef.close('Cancel was clicked.');
  }
}
